import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectSelectedOfferInfo } from "../../../selectors/selectShopInfo";
import { actionModalCloseAll, actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionShopSelectOffer, TypeActionShop } from "../actionShop";
export var epicShopOpenOffer = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShop.OpenOffer), switchMap(function (action) {
        var selectedOfferInfo = selectSelectedOfferInfo(state$.value, action.offerCharacteristicId);
        return from([
            actionModalCloseAll(),
            actionShopSelectOffer(selectedOfferInfo),
            actionModalOpen(IdModal.Shop),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopOpenOffer.ts
// module id = 2339
// module chunks = 3